module.exports = __webpack_public_path__ + "img/178-ceuta.5f80311a.svg";